export const getMenuList = (
    {
        list = [],
        rootValue = "1628606141145972737",
        keyField = 'key',
        parentField = 'parentId',
        nameField = 'name',
        pathField = 'path',
        urlPrefixField = 'urlPrefix',
        iconField = 'icon',
        menuCodeField = 'menuCode',
    }
) => {
    let menuList = list.filter(item => {
        return item[parentField] === rootValue;
    }).map(item => {
        return {
            key: item[keyField],
            name: item[nameField],
            path: item[pathField],
            urlPrefix: item[urlPrefixField],
            icon: item[iconField],
            menuCode: item[menuCodeField],
            parentField: item[parentField]
        }
    });
    menuList.forEach(item => {
        let childList = getMenuList({
            list,
            rootValue: item.key,
            keyField,
            parentField,
            nameField,
            pathField,
            urlPrefixField,
            iconField,
        });
        if (childList.length) {
            item.children = childList;
        }
    })
    return menuList;
}
export const getMenuArray = (list) => {
    let array = {};
    list.forEach((v => {
        array[v.menuCode] = v.identifier;
    }))
    return array
}
export const getParentKey = ({val, tree, titleField = 'title', keyField = "key"}) => {
    let parentKeys = [];
    tree.forEach((v) => {
        if ((v[titleField]).indexOf(val) > -1) {
            parentKeys.push(v[keyField])
        }
    })
    return parentKeys
}
export const convertTreeData = (
    {
        datas = [],
        rootValue = "1628606141145972737",
        valueField = 'value',
        titleField = 'title',
        parentField = 'parentId'
    }
) => {
    let list = datas.filter((v) => {
        return v[parentField] === rootValue;
    }).map(v => {
        return {
            key: v[valueField],
            title: v[titleField],
            value: v[valueField],
            slots: {title: 'title'}
        }
    })
    list.forEach((v) => {
        v.children = convertTreeData({
            datas,
            rootValue: v.key,
            valueField,
            titleField,
            parentField
        });
    })
    return list;
}
//组织架构
export const convertTreeDatas = (
    {
        datas = [],
        rootValue = "1628606141145972737",
        valueField = 'sn',
        titleField = 'departName',
        parentField = 'parentId'
    }
) => {
    let list = datas.filter((v) => {
        return v[parentField] === rootValue;
    }).map(v => {
        return {
            key: v[valueField],
            title: v[titleField],
            value: v[valueField],
            slots: {title: 'title'}
        }
    })
    list.forEach((v) => {
        v.children = convertTreeData({
            datas,
            rootValue: v.key,
            valueField,
            titleField,
            parentField
        });
    })
    return list;
}

export const convertSetLimitData = (dataList, checkedList, keyName = 'key') => {
    let dataObj = {}, checkedKeys = [];
    dataList.forEach(v => {
        dataObj[v[keyName]] = v.parentId
    })
    checkedList.forEach(key => {
        checkedKeys.push(key)
    })
    const addParentKey = (key) => {
        let parentId = dataObj[key];
        if (parentId && parentId !== "1628606141145972737" && (checkedKeys.includes(key) && !checkedKeys.includes(parentId))) {
            checkedKeys.push(parentId);
            addParentKey(parentId)
        }
    }
    checkedList.forEach(key => {
        addParentKey(key)
    })
    return checkedKeys
}
export const convertGetLimitData = (dataList, checkedList, keyName = 'key') => {
    let dataObj = [], checkedKeys = checkedList;
    dataList.forEach(v => {
        dataObj[v[keyName]] = v.parentId
    })
    const removeParentKey = (key) => {
        let parentId = dataObj[key];
        if (parentId !== "1628606141145972737" && parentId) {
            let index = checkedKeys.indexOf(parentId);
            if (index > -1) {
                checkedKeys.splice(index, 1)
            }
            removeParentKey(parentId)
        }
    }
    Object.keys(dataObj).forEach(key => {
        if (!checkedKeys.includes(key)) {
            removeParentKey(key)
        }
    })
    return checkedKeys
}


export const getMenuListTab = (list, key) => {
    let menuList = list.filter(v => {
        return v.parentId === key;
    });
    menuList.forEach(v => {
        v.children = getMenuListTab(list, v.menuId);
    })
    return menuList;
}

export const appAdaptation = {
    /**
     * 分页对象适配
     data = {
        list: data.records,
        pageNum: data.pages,
        total: data.total,
    };
     */
    pageData(pageInfo) {
        return {
            list: pageInfo.records,
            pageNum: pageInfo.pages,
            total: pageInfo.total,
            current:pageInfo.current
        };
    },
};
